import {
  AREA,
  CITY,
  LOCATION_TYPE,
  PIN_CODE,
  STATE,
  ZONE,
  SHIP_PIN_CODE, ALL_CITY,
} from "./type";

const initalState = {
  cities: [],
  zones: [],
  areas: [],
  state: [],
  locTypesData: [],
  pincodeData: [],
  shipToPincodeData: [],
  allCityDetails:[]
};

const locationReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CITY:
      return {
        ...state,
        cities: payload,
      };
    case ZONE:
      return {
        ...state,
        zones: payload,
      };
    case AREA:
      return {
        ...state,
        areas: payload,
      };
    case STATE:
      return {
        ...state,
        state: payload,
      };
    case LOCATION_TYPE:
      return {
        ...state,
        locTypesData: payload,
      };
    case PIN_CODE:
      return {
        ...state,
        pincodeData: payload,
      };
    case SHIP_PIN_CODE:
      return {
        ...state,
        shipToPincodeData: payload,
      };
    case ALL_CITY:
      return {
        ...state,
        allCityDetails: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default locationReducer;
